export default __webpack_public_path__ + "static/media/loader.658fa9fc.svg";